const LS_KEY_PREFIX = 'theStocks';
export var LsKey;
(function (LsKey) {
    LsKey["FAVORITE_LIBRARY_NAMES"] = "favoriteLibraryNames";
    LsKey["LATEST_FEATURED_SOURCE"] = "latestFeaturedSource";
    LsKey["DARK_MODE"] = "darkMode";
    LsKey["NEWSLETTER_MODAL_VISIBLE"] = "newsletterModalVisible";
    LsKey["PRODUCT_HUNT_DISMISSED"] = "productHuntDismissed";
})(LsKey || (LsKey = {}));
export const getStorage = (key, defaultValue = null) => {
    const storageValue = window.localStorage.getItem(`${LS_KEY_PREFIX}.${key}`);
    if (!storageValue) {
        return defaultValue;
    }
    return JSON.parse(storageValue);
};
export const setStorage = (key, value) => {
    window.localStorage.setItem(`${LS_KEY_PREFIX}.${key}`, JSON.stringify(value));
};
